angular.module('storefrontApp')
    .controller('quoteRequestController', [
        '$rootScope',
        '$scope',
        '$window',
        '$location',
        'quoteRequestService',
        'cartService',
        function (
            $rootScope,
            $scope,
            $window,
            $location,
            quoteRequestService,
            cartService,
        ) {
            initialize();

            $scope.setQuoteRequestForm = function (form) {
                $scope.formQuoteRequest = form;
            };

            $scope.displayForStatuses = function (statuses) {
                return _.contains(statuses, $scope.quoteRequest.status);
            };

            $scope.addTierPrice = function (quoteItem) {
                quoteItem.proposalPrices.push({
                    id: quoteItem.proposalPrices.length + 1,
                    price: quoteItem.salePrice,
                    quantity: 1,
                });
            };

            $scope.changeTierPriceQuantity = function (tierPrice, quantity) {
                if (quantity < 1 || quantity.isNaN) {
                    return;
                }
                tierPrice.quantity = quantity;
            };

            $scope.removeTierPrice = function (quoteItem, tierPrice) {
                quoteItem.proposalPrices = _.without(quoteItem.proposalPrices, tierPrice);
            };

            $scope.removeProductFromQuoteRequest = function (quoteItem) {
                const initialQuoteItems = angular.copy($scope.quoteRequest.items);

                $scope.quoteRequest.items = _.without($scope.quoteRequest.items, quoteItem);

                quoteRequestService.removeProductFromQuoteRequest($scope.quoteRequest.id, quoteItem.id)
                    .then(function () {
                        getQuoteRequest($scope.quoteRequest.id);
                        $rootScope.$broadcast('actualQuoteRequestItemsChanged');
                    }, function () {
                        $scope.quoteRequest.items = initialQuoteItems;
                    });
            };

            $scope.setCountry = function (addressType, countryName) {
                const country = _.find($scope.countries, function (c) {
                    return c.name === countryName;
                });

                if (!country) {
                    return;
                }

                if (addressType === 'Billing') {
                    $scope.billingCountry = country;
                    $scope.billingCountryRegions = [];
                    $scope.quoteRequest.billingAddress.countryCode = country.code3 || country.code2;
                    $scope.quoteRequest.billingAddress.regionId = null;
                    $scope.quoteRequest.billingAddress.regionName = null;
                }

                if (addressType === 'Shipping') {
                    $scope.shippingCountry = country;
                    $scope.shippingCountryRegions = [];
                    $scope.quoteRequest.shippingAddress.countryCode = country.code3 || country.code2;
                    $scope.quoteRequest.shippingAddress.regionId = null;
                    $scope.quoteRequest.shippingAddress.regionName = null;
                }

                if (country.code3) {
                    getCountryRegions(addressType, country.code3);
                }
            };

            $scope.setCountryRegion = function (addressType) {
                if (addressType === 'Billing') {
                    const countryRegion = _.find($scope.billingCountryRegions, function (r) {
                        return r.name === $scope.quoteRequest.billingAddress.regionName;
                    });

                    if (!countryRegion) {
                        return;
                    }

                    $scope.quoteRequest.billingAddress.regionId = countryRegion.code;
                }

                if (addressType === 'Shipping') {
                    const countryRegion = _.find($scope.shippingCountryRegions, function (r) {
                        return r.name === $scope.quoteRequest.shippingAddress.regionName;
                    });

                    if (!countryRegion) {
                        return;
                    }

                    $scope.quoteRequest.shippingAddress.regionId = countryRegion.code;
                }
            };

            $scope.selectCustomerAddress = function (addressType) {
                if (addressType === 'Billing') {
                    const billingAddress = _.find($scope.customer.addresses, function (a) {
                        return a.id === $scope.quoteRequest.billingAddress.id;
                    });

                    if (billingAddress) {
                        billingAddress.type = 'Billing';

                        if (billingAddress.countryCode) {
                            getCountryRegions('Billing', billingAddress.countryCode);
                        }

                        $scope.quoteRequest.billingAddress = angular.copy(billingAddress);
                    }
                }

                if (addressType === 'Shipping') {
                    const shippingAddress = _.find($scope.customer.addresses, function (a) {
                        return a.id === $scope.quoteRequest.shippingAddress.id;
                    });

                    if (shippingAddress) {
                        shippingAddress.type = 'Shipping';

                        if (shippingAddress.countryCode) {
                            getCountryRegions('Shipping', shippingAddress.countryCode);
                        }

                        $scope.quoteRequest.shippingAddress = angular.copy(shippingAddress);
                    }
                }
            };

            $scope.stringifyAddress = function (address) {
                if (!address) {
                    return '';
                }

                let stringifiedAddress = address.firstName + ' ' + address.lastName + ', ';

                stringifiedAddress += address.organization ? address.organization + ', ' : '';
                stringifiedAddress += address.countryName + ', ';
                stringifiedAddress += address.regionName ? address.regionName + ', ' : '';
                stringifiedAddress += address.city + ' ';
                stringifiedAddress += address.line1 + ', ';
                stringifiedAddress += address.line2 ? address.line2 : '';
                stringifiedAddress += address.postalCode;

                return stringifiedAddress;
            };

            $scope.submitQuoteRequest = function () {
                $scope.formQuoteRequest.$setSubmitted();

                if ($scope.formQuoteRequest.$invalid) {
                    return;
                }

                $scope.quoteRequest.billingAddress.email = $scope.quoteRequest.email;

                if ($scope.quoteRequest.shippingAddress) {
                    $scope.quoteRequest.shippingAddress.email = $scope.quoteRequest.email;
                }

                quoteRequestService.submitQuoteRequest($scope.quoteRequest.id, toFormModel($scope.quoteRequest))
                    .then(function () {
                        if ($scope.customer.isRegisteredUser) {
                            $scope.outerRedirect($scope.baseUrl + 'account/quoterequests');
                        } else {
                            $scope.outerRedirect($scope.baseUrl + 'account/login');
                        }
                    });
            };

            $scope.rejectQuoteRequest = function () {
                quoteRequestService.rejectQuoteRequest($scope.quoteRequest.id)
                    .then(function () {
                        quoteRequestService.getQuoteRequest($scope.quoteRequest.id)
                            .then(function (response) {
                                $scope.quoteRequest = response.data;
                            });
                    });
            };

            $scope.selectTierPrice = function () {
                quoteRequestService.getTotals($scope.quoteRequest.id, toFormModel($scope.quoteRequest))
                    .then(function (response) {
                        $scope.quoteRequest.totals = response.data;
                    });
            };

            $scope.confirmQuoteRequest = function () {
                quoteRequestService.confirmQuoteRequest($scope.quoteRequest.id, toFormModel($scope.quoteRequest))
                    .then(function () {
                        $scope.outerRedirect($scope.baseUrl + 'cart/checkout/#/shipping-address');
                    });
            };

            $scope.setRequestShippingQuote = function () {
                if (!$scope.quoteRequest.requestShippingQuote) {
                    $scope.quoteRequest.shippingAddress = null;
                }
            };

            $scope.setShippingAddressEqualsBilling = function () {
                if ($scope.quoteRequest.shippingAddressEqualsBilling) {
                    $scope.quoteRequest.shippingAddress = angular.copy($scope.quoteRequest.billingAddress);
                    $scope.quoteRequest.shippingAddress.type = 'Shipping';
                    if ($scope.quoteRequest.shippingAddress.countryCode) {
                        $scope.shippingCountry = $scope.billingCountry;
                        getCountryRegions('Shipping', $scope.quoteRequest.shippingAddress.countryCode);
                    }
                }
            };

            $scope.tierPricesUnique = function (quoteItem) {
                const quantities = _.map(quoteItem.proposalPrices, function (p) {
                    return p.quantity;
                });

                return _.uniq(quantities).length === quoteItem.proposalPrices.length;
            };

            function initialize() {
                const quoteRequestNumber = $location.url().replace('/', '') || $window.currentQuoteRequestNumber;

                $scope.billingCountry = null;
                $scope.shippingCountry = null;

                getCountries();

                if (quoteRequestNumber) {
                    getQuoteRequest(quoteRequestNumber);
                } else {
                    $scope.quoteRequest = { itemsCount: 0 };
                }
            }

            function getQuoteRequest(number) {
                quoteRequestService.getQuoteRequest(number)
                    .then(function (response) {
                        const quoteRequest = response.data;

                        if (!quoteRequest.billingAddress) {
                            if ($scope.customer.addresses && $scope.customer.addresses.length) {
                                quoteRequest.billingAddress = angular.copy($scope.customer.addresses[0]);
                                quoteRequest.billingAddress.type = 'Billing';
                                if (quoteRequest.billingAddress.countryCode) {
                                    getCountryRegions('Billing', quoteRequest.billingAddress.countryCode);
                                }
                            } else {
                                quoteRequest.billingAddress = {
                                    firstName: $scope.customer.firstName,
                                    lastName: $scope.customer.lastName,
                                };
                            }
                        }
                        _.each(quoteRequest.items, function (quoteItem) {
                            let i = 1;

                            _.each(quoteItem.proposalPrices, function (tierPrice) {
                                tierPrice.id = i;

                                if (quoteItem.selectedTierPrice.quantity === tierPrice.quantity) {
                                    quoteItem.selectedTierPrice = tierPrice;
                                }

                                i += 1;
                            });
                        });
                        quoteRequest.requestShippingQuote = true;
                        $scope.quoteRequest = quoteRequest;
                    });
            }

            function getCountries() {
                cartService.getCountries()
                    .then(function (response) {
                        $scope.countries = response.data;
                    });
            }

            function getCountryRegions(addressType, countryCode) {
                cartService.getCountryRegions(countryCode)
                    .then(function (response) {
                        const countryRegions = response.data;

                        if (addressType === 'Billing') {
                            $scope.billingCountryRegions = countryRegions || [];
                        }
                        if (addressType === 'Shipping') {
                            $scope.shippingCountryRegions = countryRegions || [];
                        }
                    });
            }

            function toFormModel(quoteRequest) {
                const quoteRequestFormModel = {
                    id: quoteRequest.id,
                    tag: quoteRequest.tag,
                    status: quoteRequest.status,
                    comment: quoteRequest.comment,
                    billingAddress: quoteRequest.billingAddress,
                    shippingAddress: quoteRequest.shippingAddress,
                    items: [],
                };

                _.each(quoteRequest.items, function (quoteItem) {
                    const quoteItemFormModel = {
                        id: quoteItem.id,
                        comment: quoteItem.comment,
                        selectedTierPrice: {
                            price: quoteItem.selectedTierPrice.price.amount,
                            quantity: quoteItem.selectedTierPrice.quantity,
                        },
                        proposalPrices: [],
                    };
                    _.each(quoteItem.proposalPrices, function (tierPrice) {
                        quoteItemFormModel.proposalPrices.push({
                            price: tierPrice.price.amount,
                            quantity: tierPrice.quantity,
                        });
                    });
                    quoteRequestFormModel.items.push(quoteItemFormModel);
                });

                return quoteRequestFormModel;
            }
        }])

    .controller('actualQuoteRequestBarController', [
        '$scope',
        'quoteRequestService',
        function (
            $scope,
            quoteRequestService,
        ) {
            getCurrentQuoteRequest();

            $scope.$on('actualQuoteRequestItemsChanged', function () {
                getCurrentQuoteRequest();
            });

            function getCurrentQuoteRequest() {
                quoteRequestService.getCurrentQuoteRequest()
                    .then(function (response) {
                        $scope.actualQuoteRequest = response.data;
                    });
            }
        }])

    .controller('recentlyAddedActualQuoteRequestItemDialogController', [
        '$scope',
        '$window',
        '$uibModalInstance',
        'dialogData',
        function (
            $scope,
            $window,
            $uibModalInstance,
            dialogData,
        ) {
            $scope.$on('actualQuoteRequestItemsChanged', function () {
                dialogData.updated = true;
            });

            $scope.dialogData = dialogData;

            $scope.close = function () {
                $uibModalInstance.close();
            };

            $scope.redirect = function (url) {
                $window.location = url;
            };
        }]);
